<template>
  <div id="staff-settings">
    <div id="view-sub-nav">
      <v-btn
        variant="outlined"
        color="primary"
        @click="
          () => {
            dialogMode = 'Create'
            selectedItem = newItemForm
            itemDialog = true
          }
        "
        >Create New Staff Member</v-btn
      >
      <v-btn-toggle v-if="$store.state.user.email === 'sho@plykea.com'" v-model="staffView" mandatory class="ml-4">
        <v-btn value="current" size="small">Current</v-btn>
        <v-btn value="past" size="small">Past</v-btn>
      </v-btn-toggle>
      <v-spacer />
      <v-text-field
        v-model="tableSearch"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        density="compact"
        :clearable="true"
      ></v-text-field>
    </div>
    <v-data-table
      v-if="data"
      :items="data.filter((o) => (staffView === 'current' ? !o.departureDate : !!o.departureDate))"
      :loading="loading"
      :headers="headers"
      :sort-by="[{ key: 'name', order: 'asc' }]"
      :items-per-page="-1"
      :search="tableSearch"
      id="materials-table"
    >
      <template v-slot:item.capacity="{ item }">
        <div v-if="item.staffType === 'employed'">
          <v-chip v-for="key of visibleCapacityDays(item)" :key="key" variant="outlined" class="mx-1"
            >{{ daysOfWeek[key] }}
            <v-avatar end>
              {{ item.capacity[item.capacity.length - 1].hours[key] }}
            </v-avatar>
          </v-chip>
        </div>
        <v-chip v-else-if="item.staffType === 'freelance'" variant="outlined">Freelancer</v-chip>
      </template>
      <template v-slot:item.departureDate="{ item }">
        <span v-if="item.departureDate">
          {{ $moment.unix(item.departureDate.seconds).format('Do MMM YYYY') }}
        </span>
      </template>
      <template v-slot:item.actions="{ item }">
        <td class="d-flex justify-end align-center">
          <v-tooltip location="top" :open-delay="500">
            <template v-slot:activator="{ props }">
              <v-icon
                size="small"
                class="mr-1"
                @click="
                  () => {
                    dialogMode = 'Edit'
                    itemDialog = true
                    selectedItem = item
                  }
                "
                v-bind="props"
                >mdi-pencil</v-icon
              >
            </template>
            <span>Edit Staff Member</span>
          </v-tooltip>
          <v-tooltip v-if="$store.state.user.permissions.admin" location="top" :open-delay="500">
            <template v-slot:activator="{ props }">
              <v-icon
                size="small"
                @click="
                  () => {
                    deleteDialog = true
                    selectedItem = item
                    if (staffView === 'past') tmpDepartureDate = item.departureDate
                  }
                "
                v-bind="props"
                >mdi-delete</v-icon
              >
            </template>
            <span>Delete Staff Member</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>

    <!-- CREATE / Edit -->
    <v-dialog v-model="itemDialog" width="950">
      <v-card>
        <v-card-title class="bg-primary text-white text-h6">
          {{ dialogMode == 'Create' ? 'Create New Staff Member' : 'Edit Staff Member' }}
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form ref="staffForm">
            <v-row>
              <v-col>
                <v-text-field
                  label="Name"
                  v-model="selectedItem.name"
                  :disabled="dialogMode === 'Edit'"
                  :rules="[(v) => !!v || 'Name is required']"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-select
                  v-model="selectedItem.staffType"
                  :items="staffTypes"
                  label="Staff Type"
                  :rules="[(v) => !!v || 'Staff Type is required']"
                  :disabled="dialogMode === 'Edit'"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="selectedItem.staffType === 'employed'">
              <v-col cols="12">
                <v-text-field
                  label="Timetastic ID"
                  v-model.number="selectedItem.timetasticId"
                  :disabled="dialogMode !== 'Create'"
                  :rules="[(v) => !!v || 'Timetastic ID is required']"
                  placeholder="Can be found in the URL last digits of Staff Timetastic Profile"
                  persistent-placeholder
                ></v-text-field>
              </v-col>
            </v-row>

            <div class="label mb-4 mt-4" v-if="selectedItem.staffType === 'employed'">Daily Capacity in hours</div>
            <div v-if="selectedItem.staffType === 'employed'">
              <v-row v-for="(schedule, scheduleIndex) of selectedItem.capacity" :key="scheduleIndex" align="center">
                <v-col cols="3">
                  <v-menu ref="menu" :close-on-content-click="false" transition="scale-transition" min-width="auto">
                    <template v-slot:activator="{ props }">
                      <v-text-field
                        :model-value="schedule.from ? $moment.unix(schedule.from.seconds).format('Do MMM YYYY') : null"
                        label="Start date"
                        prepend-icon="mdi-calendar"
                        :disabled="scheduleIndex !== selectedItem.capacity.length - 1"
                        :rules="[(v) => !!v || 'Start date is required']"
                        readonly
                        v-bind="props"
                      ></v-text-field>
                    </template>
                    <template v-slot:default="{ isActive }">
                      <MinimalDatePicker
                        :allowed-dates="allowedDates"
                        :model-value="$utils.dateFromTimestamp(schedule.from)"
                        :first-day-of-week="1"
                        @update:model-value="
                          (val) => {
                            schedule.from = $utils.timestampFromDate(val)
                            isActive.value = false
                          }
                        "
                      >
                      </MinimalDatePicker>
                    </template>
                  </v-menu>
                </v-col>
                <v-col>
                  <v-row>
                    <v-col v-for="(day, index) of daysOfWeek" :key="index">
                      <v-text-field
                        v-if="selectedItem.capacity"
                        :key="index"
                        :label="day"
                        variant="outlined"
                        type="number"
                        step="1"
                        min="0"
                        max="8"
                        :disabled="scheduleIndex !== selectedItem.capacity.length - 1"
                        v-model.number="schedule.hours[index]"
                        :rules="[(v) => (v !== null && v !== '') || 'Required']"
                        @change="clampHours(schedule, index)"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="auto" v-if="selectedItem.capacity.length > 1" class="d-flex align-center">
                  <v-btn icon size="small" @click="deleteSchedule(scheduleIndex)">
                    <v-icon size="small" color="grey">mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="dialogMode === 'Edit'" class="pa-0" variant="text" @click="createNewSchedule"
            ><v-icon>mdi-plus</v-icon>Create new schedule</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            variant="text"
            @click="
              () => {
                itemDialog = false
                resetNewItemValues()
              }
            "
            >Cancel</v-btn
          >
          <v-btn
            color="accent"
            variant="flat"
            @click="dialogMode === 'Create' ? createNewItem() : updateItem()"
            :disabled="submitting"
            >{{ dialogMode === 'Create' ? 'Create' : 'Update' }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DELETE -->
    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="bg-warning text-white text-h6">Remove Staff Member</v-card-title>
        <v-card-text class="pt-6">
          <v-btn-toggle v-model="deleteMode" mandatory class="mb-4">
            <v-btn value="departure">Depart</v-btn>
            <v-btn value="delete">Delete</v-btn>
          </v-btn-toggle>

          <v-form ref="deleteForm" v-if="deleteMode === 'departure'">
            <v-menu :close-on-content-click="false" transition="scale-transition" min-width="auto">
              <template v-slot:activator="{ props }">
                <v-text-field
                  :model-value="
                    tmpDepartureDate ? $utils.humanFromVuetify($utils.vuetifyTimestamp(tmpDepartureDate)) : null
                  "
                  label="Departure date"
                  prepend-icon="mdi-calendar"
                  :rules="[(v) => !!v || 'Departure date is required']"
                  readonly
                  v-bind="props"
                ></v-text-field>
              </template>
              <template v-slot:default="{ isActive }">
                <MinimalDatePicker
                  :model-value="$utils.dateFromTimestamp(tmpDepartureDate)"
                  @update:model-value="
                    (val) => {
                      tmpDepartureDate = $utils.timestampFromDate(val)
                      isActive.value = false
                    }
                  "
                >
                </MinimalDatePicker>
              </template>
            </v-menu>
          </v-form>

          <v-alert v-else type="error" variant="outlined">
            This staff member will be completely removed from all schedule logs
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="text" @click="cancelDelete">Cancel</v-btn>
          <v-btn color="warning" variant="flat" @click="confirmDelete">
            {{ deleteMode === 'departure' ? 'Depart' : 'Delete' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- CONFIRM -->
    <v-dialog v-model="confirmDialog" width="500">
      <v-card>
        <v-card-title class="bg-warning text-white text-h6">Are you sure?</v-card-title>
        <v-card-text class="pt-6">
          <span v-if="deleteMode === 'departure' && staffView === 'past' && departureDateDirection === 'later'">
            <strong>{{ selectedItem.name }}</strong> will be restored to schedule logs between
            <strong>{{ $utils.humanFromVuetify($utils.vuetifyTimestamp(selectedItem.departureDate)) }}</strong> and
            <strong>{{ $utils.humanFromVuetify($utils.vuetifyTimestamp(tmpDepartureDate)) }}</strong
            >.
          </span>
          <span v-else-if="deleteMode === 'departure' && staffView === 'past' && departureDateDirection === 'earlier'">
            <strong>{{ selectedItem.name }}</strong> will have schedule logs between
            <strong>{{ $utils.humanFromVuetify($utils.vuetifyTimestamp(tmpDepartureDate)) }}</strong> and
            <strong>{{ $utils.humanFromVuetify($utils.vuetifyTimestamp(selectedItem.departureDate)) }}</strong> removed.
          </span>
          <span v-else-if="deleteMode === 'departure'">
            <strong>{{ selectedItem.name }}</strong> will have all schedule logs after
            <strong>{{
              tmpDepartureDate ? $utils.humanFromVuetify($utils.vuetifyTimestamp(tmpDepartureDate)) : ''
            }}</strong>
            removed.
          </span>
          <span v-else>
            <strong>{{ selectedItem.name }}</strong> will be completely removed and have all schedule logs deleted.
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="text" @click="confirmDialog = false">Cancel</v-btn>
          <v-btn color="warning" variant="flat" @click="executeDelete">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { db } from '@/js/db'
import { collection, deleteDoc, doc, getDocs, query, setDoc, updateDoc, where, writeBatch } from 'firebase/firestore'
import MinimalDatePicker from '@/components/ui/MinimalDatePicker'

export default {
  name: 'StaffSettings',
  components: { MinimalDatePicker },
  data() {
    return {
      staffView: 'current',
      loading: true,
      tableSearch: null,
      deleteMode: 'departure',
      tmpDepartureDate: null,
      confirmDialog: false,
      deleteDialog: false,
      itemDialog: false,
      submitting: false,
      selectedItem: {},
      dialogMode: null,
      newItemForm: {},
      data: null,
      daysOfWeek: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      staffTypes: [
        { text: 'Employed', value: 'employed' },
        { text: 'Freelance', value: 'freelance' }
      ]
    }
  },
  watch: {
    deleteMode(val) {
      if (val === 'departure' && this.staffView === 'past' && this.selectedItem.departureDate) {
        this.tmpDepartureDate = this.selectedItem.departureDate
      } else {
        this.tmpDepartureDate = null
      }
    },
    'selectedItem.staffType'(newVal, oldVal) {
      if (this.dialogMode === 'Create' && oldVal !== null && oldVal !== newVal) {
        this.selectedItem.timetasticId = null
        this.selectedItem.capacity = [
          {
            from: null,
            hours: [null, null, null, null, null, null, null]
          }
        ]
      }
    }
  },
  computed: {
    headers() {
      const h = [
        { title: 'Name', sortable: true, key: 'name' },
        { title: 'Capacity', sortable: true, key: 'capacity' }
      ]
      if (this.staffView === 'past') {
        h.push({ title: 'Departure Date', sortable: true, key: 'departureDate' })
      }
      h.push({ title: 'Actions', sortable: false, align: 'end', key: 'actions' })
      return h
    },
    departureDateDirection() {
      if (!this.selectedItem.departureDate || !this.tmpDepartureDate) return null
      const oldMoment = this.$moment.unix(this.selectedItem.departureDate.seconds)
      const newMoment = this.$moment.unix(this.tmpDepartureDate.seconds)
      if (newMoment.isAfter(oldMoment)) return 'later'
      if (newMoment.isBefore(oldMoment)) return 'earlier'
      return 'same'
    }
  },
  async mounted() {
    this.resetNewItemValues()
    await this.$live('data', collection(db, 'staff'))
    this.loading = false
  },
  methods: {
    visibleCapacityDays(item) {
      const hours = item.capacity[item.capacity.length - 1].hours
      return Object.keys(hours).filter((key) => item.capacity[key] !== null)
    },
    resetNewItemValues() {
      this.newItemForm = {
        name: null,
        staffType: null,
        timetasticId: null,
        capacity: [
          {
            from: null,
            hours: [null, null, null, null, null, null, null]
          }
        ]
      }
    },
    draftSchedule(s) {
      const nullHours = s.hours.findIndex((v) => v === null)
      return s.from === null || nullHours !== -1 ? true : false
    },
    allowedDates(val) {
      if (this.dialogMode === 'Create') {
        return true
      } else {
        return this.$moment(val).isAfter(
          this.$moment.unix(this.selectedItem.capacity[this.selectedItem.capacity.length - 2].from.seconds)
        )
      }
    },
    async createNewItem() {
      if (!(await this.$utils.validateForm(this.$refs.staffForm))) return
      this.submitting = true

      const newDocRef = doc(collection(db, 'staff'))
      await setDoc(newDocRef, this.newItemForm)

      this.resetNewItemValues()
      this.submitting = false
      this.itemDialog = false
    },
    async updateItem() {
      if (!(await this.$utils.validateForm(this.$refs.staffForm))) return
      this.submitting = true
      await setDoc(doc(db, 'staff', this.selectedItem.id), this.selectedItem)

      this.submitting = false
      this.itemDialog = false
      this.$store.commit('openSnackbar', {
        snackbarText: 'Staff Member Updated'
      })
    },
    deleteItem(item) {
      this.deleteDialog = false
      deleteDoc(doc(db, 'staff', item.id))
        .then(() => {
          this.$store.commit('openSnackbar', {
            snackbarText: 'Staff Member Deleted'
          })
        })
        .catch((err) => {
          this.$store.commit('openSnackbar', { snackbarText: 'Error: ' + err })
        })
    },
    cancelDelete() {
      this.deleteDialog = false
      this.tmpDepartureDate = null
      this.deleteMode = 'departure'
    },
    async confirmDelete() {
      if (this.deleteMode === 'departure' && !(await this.$utils.validateForm(this.$refs.deleteForm))) return
      this.deleteDialog = false
      this.confirmDialog = true
    },
    executeDelete() {
      this.confirmDialog = false
      if (this.deleteMode === 'departure') {
        if (this.staffView === 'past') {
          this.updateDepartureDate()
        } else {
          this.removeStaffMember()
        }
      } else {
        this.permanentlyDeleteStaff()
      }
    },
    async updateDepartureDate() {
      const direction = this.departureDateDirection
      if (direction === 'same') return

      const oldDate = this.selectedItem.departureDate
      const newDate = this.tmpDepartureDate

      if (direction === 'later') {
        await this.restoreStaffToCapacity(oldDate, newDate)
      } else {
        await this.removeStaffFromCapacityRange(newDate, oldDate)
      }

      await updateDoc(doc(db, 'staff', this.selectedItem.id), {
        departureDate: newDate
      })

      this.tmpDepartureDate = null
      this.deleteMode = 'departure'
      this.$store.commit('openSnackbar', { snackbarText: 'Departure Date Updated' })
    },
    getStaffHoursForDate(staff, momentDay) {
      let schedule
      for (const s of staff.capacity) {
        if (!s.from) continue
        const startMoment = this.$moment.unix(s.from.seconds)
        if (!schedule && startMoment.isSameOrBefore(momentDay)) {
          schedule = s
        } else if (
          schedule &&
          startMoment.isSameOrBefore(momentDay) &&
          startMoment.isAfter(this.$moment.unix(schedule.from.seconds))
        ) {
          schedule = s
        }
      }
      return schedule ? schedule.hours[momentDay.isoWeekday() - 1] : 0
    },
    async restoreStaffToCapacity(fromDate, toDate) {
      if (this.selectedItem.staffType !== 'employed') return

      const capacitySnap = await getDocs(
        query(collection(db, 'capacity'), where('date', '>=', fromDate), where('date', '<', toDate))
      )

      const batch = writeBatch(db)

      capacitySnap.forEach((docSnap) => {
        const data = docSnap.data()
        const alreadyWorking = (data.working || []).some((w) => w.timetasticId === this.selectedItem.timetasticId)
        if (alreadyWorking) return

        const momentDay = this.$moment.unix(data.date.seconds)
        const hours = this.getStaffHoursForDate(this.selectedItem, momentDay)
        if (hours > 0) {
          const working = [
            ...(data.working || []),
            {
              name: this.selectedItem.name,
              timetasticId: this.selectedItem.timetasticId,
              hours
            }
          ]
          batch.update(docSnap.ref, { working })
        }
      })

      await batch.commit()
    },
    async removeStaffFromCapacityRange(fromDate, toDate) {
      const staffId = this.selectedItem.id
      const timetasticId = this.selectedItem.timetasticId
      const isEmployed = this.selectedItem.staffType === 'employed'

      const capacitySnap = await getDocs(
        query(collection(db, 'capacity'), where('date', '>=', fromDate), where('date', '<', toDate))
      )

      const batch = writeBatch(db)

      capacitySnap.forEach((docSnap) => {
        const data = docSnap.data()
        let changed = false
        const update = {}

        if (isEmployed) {
          const working = (data.working || []).filter((w) => w.timetasticId !== timetasticId)
          const overtime = (data.overtime || []).filter((o) => o.timetasticId !== timetasticId)
          const sick = (data.sick || []).filter((s) => s.timetasticId !== timetasticId)
          if (working.length !== (data.working || []).length) {
            update.working = working
            changed = true
          }
          if (overtime.length !== (data.overtime || []).length) {
            update.overtime = overtime
            changed = true
          }
          if (sick.length !== (data.sick || []).length) {
            update.sick = sick
            changed = true
          }
        } else {
          const freelancers = (data.freelancers || []).filter((f) => f.id !== staffId)
          if (freelancers.length !== (data.freelancers || []).length) {
            update.freelancers = freelancers
            changed = true
          }
        }

        const holidays = (data.holidays || []).filter((h) => h.id !== staffId)
        if (holidays.length !== (data.holidays || []).length) {
          update.holidays = holidays
          changed = true
        }

        if (changed) batch.update(docSnap.ref, update)
      })

      await batch.commit()
    },
    async removeStaffFromCapacity(fromDate) {
      const staffId = this.selectedItem.id
      const timetasticId = this.selectedItem.timetasticId
      const isEmployed = this.selectedItem.staffType === 'employed'

      const constraints = fromDate ? [where('date', '>=', fromDate)] : []

      const capacitySnap = await getDocs(query(collection(db, 'capacity'), ...constraints))
      const batch = writeBatch(db)

      capacitySnap.forEach((docSnap) => {
        const data = docSnap.data()
        let changed = false
        const update = {}

        if (isEmployed) {
          const working = (data.working || []).filter((w) => w.timetasticId !== timetasticId)
          const overtime = (data.overtime || []).filter((o) => o.timetasticId !== timetasticId)
          const sick = (data.sick || []).filter((s) => s.timetasticId !== timetasticId)
          if (working.length !== (data.working || []).length) {
            update.working = working
            changed = true
          }
          if (overtime.length !== (data.overtime || []).length) {
            update.overtime = overtime
            changed = true
          }
          if (sick.length !== (data.sick || []).length) {
            update.sick = sick
            changed = true
          }
        } else {
          const freelancers = (data.freelancers || []).filter((f) => f.id !== staffId)
          if (freelancers.length !== (data.freelancers || []).length) {
            update.freelancers = freelancers
            changed = true
          }
        }

        const holidays = (data.holidays || []).filter((h) => h.id !== staffId)
        if (holidays.length !== (data.holidays || []).length) {
          update.holidays = holidays
          changed = true
        }

        if (changed) batch.update(docSnap.ref, update)
      })

      await batch.commit()
    },
    async removeStaffMember() {
      await updateDoc(doc(db, 'staff', this.selectedItem.id), {
        departureDate: this.tmpDepartureDate
      })
      await this.removeStaffFromCapacity(this.tmpDepartureDate)
      this.tmpDepartureDate = null
      this.deleteMode = 'departure'
      this.$store.commit('openSnackbar', { snackbarText: 'Staff Member Departed' })
    },
    async permanentlyDeleteStaff() {
      await this.removeStaffFromCapacity(null)
      await deleteDoc(doc(db, 'staff', this.selectedItem.id))
      this.deleteMode = 'departure'
      this.$store.commit('openSnackbar', { snackbarText: 'Staff Member Permanently Deleted' })
    },
    clampHours(schedule, index) {
      let val = schedule.hours[index]
      if (val === null || val === '') return
      val = Math.round(val)
      val = Math.min(8, Math.max(0, val))
      schedule.hours[index] = val
    },
    deleteSchedule(index) {
      this.selectedItem.capacity.splice(index, 1)
    },
    createNewSchedule() {
      this.selectedItem.capacity.push({
        from: null,
        hours: [null, null, null, null, null, null, null]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.v-avatar {
  background: $sand;
}
</style>
